import { createReducer } from '@common/redux-utils';
import { CustomerViewModel } from '@models/Customer';
import { ContractDetailsViewModel } from '@models/Contract';

import {
  CloseAction,
  ContractTransferActionType,
  GetContractFailureAction,
  GetContractStartAction,
  GetContractSuccessAction,
  GotoPageAction,
  ResetAction,
  SetCustomerAction,
  TransferContractFailureAction,
  TransferContractStartAction,
  TransferContractSuccessAction
} from './contract-transfer.actions';
import { ContractTransferComponentPage } from './_components/contract-transfer.component';

// Defining the state of the page.

// Should be one per page.
// All properties should be readonly.
export interface ContractTransferState {
  contract?: ContractDetailsViewModel;
  customer?: CustomerViewModel;
  page: ContractTransferComponentPage;
  shouldShowSuccessModal?: boolean;
  isLoading: boolean;
}
// This is the initial state of the page
const initialState: ContractTransferState = {
  page: ContractTransferComponentPage.CustomerPicker,
  isLoading: false
};

function handleClose(state: ContractTransferState, action: CloseAction): ContractTransferState {
  return {
    ...state,
    shouldShowSuccessModal: false
  };
}

function handleGetContractFailure(
  state: ContractTransferState,
  action: GetContractFailureAction
): ContractTransferState {
  return state;
}

function handleGetContractStart(state: ContractTransferState, action: GetContractStartAction): ContractTransferState {
  return state;
}

function handleGetContractSuccess(
  state: ContractTransferState,
  action: GetContractSuccessAction
): ContractTransferState {
  return {
    ...state,
    contract: action.contract
  };
}

function handleGotoPage(state: ContractTransferState, action: GotoPageAction): ContractTransferState {
  return {
    ...state,
    page: action.page
  };
}

function handleReset(state: ContractTransferState, action: ResetAction): ContractTransferState {
  return initialState;
}

function handleSetCustomer(state: ContractTransferState, action: SetCustomerAction): ContractTransferState {
  return {
    ...state,
    customer: action.customer
  };
}

function handleTransferContractFailure(
  state: ContractTransferState,
  action: TransferContractFailureAction
): ContractTransferState {
  return {
    ...state,
    isLoading: false
  };
}

function handleTransferContractStart(
  state: ContractTransferState,
  action: TransferContractStartAction
): ContractTransferState {
  return {
    ...state,
    isLoading: true
  };
}

function handleTransferContractSuccess(
  state: ContractTransferState,
  action: TransferContractSuccessAction
): ContractTransferState {
  return {
    ...state,
    shouldShowSuccessModal: true,
    page: ContractTransferComponentPage.None,
    isLoading: false
  };
}

// This creates the reducer as redux wants it w/ a helper function
// There should an entry for each action type
export const ContractTransferReducer = createReducer(initialState, {
  [ContractTransferActionType.Close]: handleClose,
  [ContractTransferActionType.GetContractFailure]: handleGetContractFailure,
  [ContractTransferActionType.GetContractStart]: handleGetContractStart,
  [ContractTransferActionType.GetContractSuccess]: handleGetContractSuccess,
  [ContractTransferActionType.GotoPage]: handleGotoPage,
  [ContractTransferActionType.Reset]: handleReset,
  [ContractTransferActionType.SetCustomer]: handleSetCustomer,
  [ContractTransferActionType.TransferContractFailure]: handleTransferContractFailure,
  [ContractTransferActionType.TransferContractStart]: handleTransferContractStart,
  [ContractTransferActionType.TransferContractSuccess]: handleTransferContractSuccess
});



// WEBPACK FOOTER //
// ./src/contract/_components/contract-transfer/contract-transfer.reducer.ts